const initialState = {
  loggedIn: false
};

const adminReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN':
      return { ...state, loggedIn: true };
    default:
      return state;
  }
};

export default adminReducer;
